import moment, { Moment } from 'moment';

import analytics from './analytics';

export const NOTIFICATION_CLICKED_EVENT = 'pro_notification_clicked';
export const NOTIFICATION_VIEWED_EVENT = 'pro_notification_viewed';

export const getFromNowDisplay = (time: Moment | string | Date) => {
  const now = moment();
  const creationTime = moment(time);
  const diff = now.diff(creationTime, 'minutes');
  if (diff <= 5) {
    return 'Just Now';
  }
  return creationTime.fromNow();
};

type Notification ={
  uuid: string,
  appointment_id: number,
  client_id: number,
  provider_id: number,
  service_id: number,
  service_name: string,
  total_appt_cost: number | string,
  is_new_client_delivery: boolean,
  is_smart_price: boolean,
  type: string,
};
/**
 * creates the notification params for tracking purposes
 * @param {Object} notification - the notification object
 * @return {Object} params - params for tracking
 */
export const createNotificationParams = (notification: Notification) => ({
  notification_key: notification.uuid,
  appointment_id: notification.appointment_id,
  client_id: notification.client_id,
  provider_id: notification.provider_id,
  service_id: notification.service_id,
  service_name: notification.service_name,
  service_cost: notification.total_appt_cost,
  is_new_client_delivery: notification.is_new_client_delivery,
  is_smart_price: notification.is_smart_price,
  notification_type: notification.type,
});

/**
 * Track a notification click
 * @param   {Object} notification The notification object
 * @param   {Object} params The tracking params
 * @returns {undefined}
 */
export const trackNotificationClick = (notification: Notification) => {
  const params = createNotificationParams(notification);
  analytics.track(NOTIFICATION_CLICKED_EVENT, params);
};
